// extracted by mini-css-extract-plugin
export var statItem = "_m5-1";
export var statsRow = "_m5-0";